import { render, staticRenderFns } from "./Colorbar.vue?vue&type=template&id=4a18ff10&scoped=true"
import script from "./Colorbar.vue?vue&type=script&lang=js"
export * from "./Colorbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a18ff10",
  null
  
)

export default component.exports